import React from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import CashinTable from '../components/CashinTable';

const CashInPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <CashinTable></CashinTable>
    </Container>
  )
}
export default withAuth (CashInPage, ['admin', 'agent'])